module.exports = __webpack_public_path__ + "img/bait_yes.2167685b.png";